import React from "react";
import { useParams } from "react-router-dom";
import { useTripContext } from "../TripContext";
import { Outlet } from "react-router-dom";
import "../../../css/View/VariantLayout.css";

const VariantLayout = () => {
  const { variantguid } = useParams();
  const { tripData } = useTripContext();

  const variant = tripData?.variants?.find((v) => v.guid === variantguid);

  return (
    <div className="variant-layout-container">
      <div className="variant-layout-name">{variant && variant.name}</div>
      <Outlet />
    </div>
  );
};

export default VariantLayout;
